<template>
  <v-container fluid id="solucao-section" class="solucao-section pa-0">
    <v-container>
      <v-row align="center" justify="space-between">

        <!-- LADO ESQUERDO -->
        <v-col cols="12" md="6">
          <div class="comparison-card">

            <!-- ANTES / DEPOIS -->
            <div class="comparison-top">

              <div class="box antes">
                <div class="box-title red--text">ANTES</div>
                <ul>
                  <li>❌ Planilhas manuais</li>
                  <li>❌ Papelada solta</li>
                  <li>❌ Sem controle</li>
                  <li>❌ WhatsApp caótico</li>
                </ul>
              </div>

              <div class="box depois">
                <div class="box-title" >DEPOIS</div>
                <ul>
                  <li>✅ Sistema integrado</li>
                  <li>✅ Docs digitais</li>
                  <li>✅ Controle total</li>
                  <li>✅ Chatbot inteligente</li>
                </ul>
              </div>

            </div>

            <!-- MÉTRICAS -->
            <div class="metrics-bottom">

              <div class="metric">
                <div class="metric-value">70%</div>
                <div class="metric-label">
                  menos tempo <br> administrativo
                </div>
              </div>

              <div class="metric">
                <div class="metric-value">50%</div>
                <div class="metric-label">
                  redução <br> de erros
                </div>
              </div>

              <div class="metric">
                <div class="metric-value">3x</div>
                <div class="metric-label">
                  mais <br> controle
                </div>
              </div>

            </div>

          </div>
        </v-col>

        <!-- LADO DIREITO -->
        <v-col cols="12" md="6">

          <div class="section-label">A SOLUÇÃO</div>

          <h2 class="section-title">
            Tudo que sua transportadora precisa
            em <span class="highlight">um só sistema</span>
          </h2>

          <p class="section-subtitle">
            O Machado Web Transportadoras centraliza toda a operação da sua
            empresa, do cadastro de motoristas ao financeiro.
          </p>

          <ul class="benefits-list">
            <li><v-icon small color="#1ED760">mdi-check-circle</v-icon> Cadastro completo de motoristas e veículos</li>
            <li><v-icon small color="#1ED760">mdi-check-circle</v-icon> Alertas automáticos de vencimentos</li>
            <li><v-icon small color="#1ED760">mdi-check-circle</v-icon> Diário de bordo digital</li>
            <li><v-icon small color="#1ED760">mdi-check-circle</v-icon> Controle financeiro detalhado</li>
            <li><v-icon small color="#1ED760">mdi-check-circle</v-icon> Chatbot WhatsApp integrado</li>
            <li><v-icon small color="#1ED760">mdi-check-circle</v-icon> Dashboard estratégico</li>
          </ul>

          <v-btn
            large
            rounded
            color="#1ED760"
            class="white--text font-weight-bold mt-6 glow-btn"
            to="/cadastro"
          >
            Quero conhecer
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>

        </v-col>

      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "SecaoSolucao"
}
</script>

<style scoped>

.solucao-section {
  /* background: radial-gradient(circle at bottom right, #0f172a, #020617); */
  min-height: 100vh;
  display: flex;
  align-items: center;
  color: white;
}

.section-label {
  color: #10b981;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.section-title {
  font-size: 42px;
  font-weight: 800;
  line-height: 1.2;
}

.highlight {
  color: #10b981;
}

.section-subtitle {
  margin-top: 20px;
  color: #94a3b8;
  font-size: 16px;
  max-width: 500px;
}

.benefits-list {
  margin-top: 25px;
  list-style: none;
  padding: 0;
}

.benefits-list li {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #cbd5e1;
}

.comparison-card {
  background: #0b1220;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 0 60px rgba(0, 255, 150, 0.05);
}

.comparison-top {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.box {
  flex: 1;
  padding: 20px;
  border-radius: 12px;
  background: #111827;
}

.antes {
  border: 1px solid rgba(255, 0, 0, 0.2);
}

.depois {
  border: 1px solid #10b981;
}

.box-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #10b981;
}

.box ul {
  padding-left: 0;
  list-style: none;
  font-size: 14px;
  color: #cbd5e1;
}

.box li {
  margin-bottom: 8px;
}

.metrics-bottom {
  display: flex;
  justify-content: space-between;
}

.metric {
  background: #111827;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  flex: 1;
  margin-right: 10px;
}

.metric:last-child {
  margin-right: 0;
}

.metric-value {
  font-size: 28px;
  font-weight: bold;
  color: #10b981;
}

.metric-label {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 8px;
}

.glow-btn {
  box-shadow: 0 0 20px #1ed76066;
}

</style>